module.exports = __webpack_public_path__ + "media/images/create_mare_fee-82f771c349e0afe8f491f9d54076af4e.png";